import ProfilePicker from '@admin/components/profile_picker'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import React from 'react'

class Profile extends React.Component {

  static propTypes = {
    onDone: PropTypes.func
  }

  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <ProfilePicker { ...this._getProfilePicker() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      showHeader: false
    }
  }

  _getProfilePicker() {
    return {
      label: 't(Choose a Canva Account)',
      empty: {
        image: '/images/services/canva.png',
        title: 't(Connect to Canva)',
        text: 't(You have not yet connected any Canva accounts)'
      },
      showHeader: false,
      sources: ['canva'],
      onDone: this._handleSuccess
    }
  }

  _handleSuccess(profile) {
    this.props.onDone({profile})
  }

}

export default Profile

